import React, { useContext, useEffect, useRef, useState } from 'react';
import { onClickPageButtonTracking, usePageTracking, useScrollTracking } from '../../../hooks/pageTracking';
import { DeepLinkDefaultLink, getDeepLinkUri } from '../../../utils/deepLinkUtils';
import { ModalContext } from '../../../contexts/ModalContext';
import LandingFooter from '../../../components/landing/LandingFooter';

export default function AppThemeTestB() {
  const PAGE_NAME = 'APP_THEME_TEST_B';
  const scrollRef = useRef<HTMLDivElement>(null);
  const [deepLinkUri, setDeepLinkUri] = useState(DeepLinkDefaultLink);
  const BUTTON_LABEL = '수면 뇌로 변화시키기';
  const MODAL_BUTTON_LABEL = '확인 후 다운로드로 이동';

  const { handleModal } = useContext(ModalContext);
  const [isModalOpen, setModalOpen] = useState(false);

  usePageTracking(PAGE_NAME);
  useScrollTracking(scrollRef, PAGE_NAME);

  const fetchAndSetDeepLinkUri = async () => {
    const deepLinkUri = await getDeepLinkUri(PAGE_NAME.toLowerCase());
    if (deepLinkUri) {
      console.log('[Success] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
      setDeepLinkUri(deepLinkUri);
    } else {
      console.error('[Failed] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
    }
  };
  useEffect(() => {
    fetchAndSetDeepLinkUri();
  }, []);

  const Modal = () => {
    return isModalOpen ? (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#000000ab',
        }}
        onClick={() => setModalOpen(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            display: 'flex',
            width: 320,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            borderRadius: 20,
            backgroundColor: '#191F28',
            color: '#FFF',
          }}
        >
          <div style={{ padding: '36px 30px 20px 30px' }}>
            <h3 className='landing_modal_h3'>‘뇌파 주파수', ‘뇌 유형검사' 기능은 아직 개발 중이에요.</h3>
            <p className='landing_modal_text'>여러분의 관심과 반응을 확인하기 위한 <b>작은 실험이었어요.</b> 여러분의 관심 덕분에 더 빠르게 만날 수 있을 거예요.</p>
            <h2 className='landing_modal_h2 mt-[20px]'>하지만 걱정 마세요!</h2>
            <p className='landing_modal_text'>그 외의 주요 기능은 지금 바로 써보실 수 있어요. 이미 많은 분들이 사용 중인 기능들을 지금 경험해보세요. 😊</p>
          </div>
          <div
            style={{
              padding: '10px 24px 20px 24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <a
              href={deepLinkUri}
              onClick={() => onClickPageButtonTracking(PAGE_NAME, MODAL_BUTTON_LABEL)}
              style={{
                textAlign: 'center',
                fontSize: 18,
                fontWeight: 600,
                letterSpacing: -0.45,
                borderRadius: 8,
                backgroundColor: '#4F68FC',
                height: 58,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 16,
                color: '#FFF',
                width: 272,
                cursor: 'pointer',
              }}
            >
              {MODAL_BUTTON_LABEL}
            </a>
          </div>
        </div>
      </div>
    ) : null;
  };

  return (
    <div ref={scrollRef} className='landing-wrap'>
      <img src="/landing/B.jpg" alt="상세페이지 이미지" style={{ width: '100%', display: 'block' }} />
      <div
        onClick={() => {
          onClickPageButtonTracking(PAGE_NAME, BUTTON_LABEL);
          setModalOpen(true);
        }}
          id='floating-button'
        className='landing-floating-btn landing-floating-active-btn'
      >
        {BUTTON_LABEL}
      </div>
      <Modal />
      <LandingFooter />
    </div>
  );
}
